const currentChallengeTransPath = 'currentChallenge.';
const gaPath = 'identifyingGA.'

const currentTrans = {
    WATCH_TITLE: gaPath + 'watchAndDiscover',
    WATCH_DESCRIPTION: currentChallengeTransPath + 'discoverDescription',
    VIDEO_DOWNLOAD_CAPTION: currentChallengeTransPath + 'downloadCaption',

    MORE_THAN_YOU_REALIZE: currentChallengeTransPath + 'moreThanYouRealise',
    MORE_THAN_YOU_REALIZE_DESC: currentChallengeTransPath + 'moreThanYouRealiseDesc',

    FEAR_OF_VISION_LOSS : currentChallengeTransPath + 'fearOfVisionLoss',
    FEAR_OF_VISION_LOSS_DESC : currentChallengeTransPath + 'fearOfVisionLossDesc',

    WHICH_LEADS_TO : currentChallengeTransPath + 'whichLeadsTo',

    EXPANDING_POPULATION : currentChallengeTransPath + 'expandingPopulation',
    EXPANDING_POPULATION_DESC : currentChallengeTransPath + 'expandingPopulationDesc'    
}

export default currentTrans